export default {
  data () {
    return {
      formIdentifier: Math.random().toString(36).substring(2, 10)
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.$store.getters.hasForm(this.formIdentifier)) {
      this.$store.dispatch('showModal', {
        component: {
          is: 'MessageModal',
          data: {
            message: this.$i18n.t('sentence.leaveFormModalText')
          }
        },
        options: {
          title: this.$i18n.t('sentence.leaveFormModalTitle'),
          canClose: false,
          size: 'md'
        },
        events: {
          ok: () => {
            this.$store.dispatch('removeForm', this.formIdentifier).then(() => next())
          },
          cancel: () => next(false)
        },
        actions: [{
          onClick: ({ cancel }) => cancel(),
          options: {
            title: this.$i18n.t('label.leaveFormModalCancel'),
            variant: 'link',
            class: 'mr-3'
          }
        }, {
          onClick: ({ ok }) => ok(),
          options: {
            title: this.$i18n.t('label.leaveFormModalConfirmation'),
            variant: 'danger',
            isPill: true
          }
        }]
      })
    } else {
      next()
    }
  }
}
